document.addEventListener('DOMContentLoaded', () => {
  // Init gtm after 3500 seconds
  setTimeout(initGTM, 3500)
})
document.addEventListener('scroll', initGTMOnEvent)
document.addEventListener('mousemove', initGTMOnEvent)
document.addEventListener('touchstart', initGTMOnEvent)

function initGTMOnEvent(event) {
  initGTM()

  // Remove the event listener that got triggered
  event.currentTarget.removeEventListener(event.type, initGTMOnEvent)
}

function initGTM() {
  if (window.gtmDidInit) {
    return false
  }

  // Flag to ensure script does not get added to DOM more than once.
  window.gtmDidInit = true
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    // Ensures PageViews is always tracked
    w[l].unshift({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })

    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl + process.env.VUE_APP_GOOGLE_TAG_PARAMS
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', 'GTM-W7ZG7NG')
}
